import * as Sentry from "@sentry/react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { routes } from "./routes/AppRouter.tsx";
import { ThemeProvider } from "./components/material-old";
import { StoreProvider } from "./redux/provider.tsx";
import { ConfigProvider } from "antd";
import spanish from "antd/es/locale/es_ES";
import dayjs from "dayjs";
import { SentryErrorFallback } from "./components/SentryErrorBoundary";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";

dayjs.locale("es");

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const router = sentryCreateBrowserRouter(routes);

export default function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={SentryErrorFallback}
      showDialog
      dialogOptions={{
        title: "Parece que hubo un problema",
        subtitle: "Nuestro equipo ha sido notificado.",
        subtitle2:
          "Si deseas ayudarnos, cuéntanos qué sucedió antes del error.",
        labelName: "Nombre",
        labelEmail: "Correo electrónico",
        labelComments: "¿Qué sucedió?",
        labelClose: "Cerrar",
        labelSubmit: "Enviar reporte",
        successMessage: "¡Gracias! Tu reporte ha sido enviado.",
      }}
      onError={(error, errorInfo) => {
        console.error("Application error:", error, errorInfo);
      }}
    >
      <div className="App">
        <ThemeProvider>
          <ConfigProvider locale={spanish}>
            <QueryClientProvider client={queryClient}>
              <StoreProvider>
                <RouterProvider router={router} />
              </StoreProvider>
            </QueryClientProvider>
          </ConfigProvider>
        </ThemeProvider>
      </div>
    </Sentry.ErrorBoundary>
  );
}
